class VatToggle extends HTMLElement {
  constructor() {
    super();
    this.switchEl = this.querySelector('.vat-toggle__switch');
    this.onSwitchClick = this.onSwitchClick.bind(this);
    this.onModeChange = this.onModeChange.bind(this);
  }

  connectedCallback() {
    this.switchEl.addEventListener('click', this.onSwitchClick);
    this.sync(this.currentMode);
    document.addEventListener('vat-mode:change', this.onModeChange);
  }

  disconnectedCallback() {
    this.switchEl.removeEventListener('click', this.onSwitchClick);
    document.removeEventListener('vat-mode:change', this.onModeChange);
  }

  get currentMode() {
    return document.documentElement.getAttribute('data-vat-mode') || this.dataset.defaultMode || 'incl';
  }

  onModeChange(event) {
    this.sync(event.detail.mode);
  }

  onSwitchClick() {
    const mode = this.currentMode === 'incl' ? 'excl' : 'incl';

    document.documentElement.setAttribute('data-vat-mode', mode);
    theme.storageUtil.set('vat-mode', mode);
    document.dispatchEvent(new CustomEvent('vat-mode:change', { detail: { mode } }));
  }

  sync(mode) {
    this.switchEl.setAttribute('aria-checked', String(mode === 'excl'));
  }
}

customElements.define('vat-toggle', VatToggle);
